import React from "react";
import styled from 'styled-components';
import BrBrandAndPdList from './BrBrandAndPdList'
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { getBrandStatInfoAction } from '../../modules/common/brandModule';
import LoadingOverlay from 'react-loading-overlay';
import { setSetBrandFilterDataAction, getBrandInfoAddAction, getBrandInfoAction } from '../../modules/common/brandModule';
import {isMobileOnly} from 'react-device-detect';

Modal.setAppElement('#modal-root');

const BrandTableBloc = styled.div`
    display: ${props => props.display};
`;

const BrandTableListUlBloc = styled.ul`
    ${isMobileOnly?`
    padding-top: 30px;
    `:`
    margin-top: -35px;
    margin-bottom: 40px;
    `};
    
`;

const BrandAddViewBloc = styled.div`
    text-align: center;
`;

const BrandAddViewBtnBloc = styled.button`
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    display: ${props => props.display};//inline-block;
    border-radius: 4px;
`;

const BrandNoItemBloc = styled.div`
    position: relative;
    height: 180px;
`;

const BrandLoadingItemBloc = styled.div`
    position: relative;
    height: 360px;
`;

const BrandNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const StyleLoader = styled(LoadingOverlay)`
    padding:0px;
    margin : 0px;
    margin-top: -30px;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const BRAND_ITEM_OFFSET = 10;

const BrBrandHomeListContainer = () => {
    const dispatch = useDispatch();
    const [addView, setAddView] = useState(false);
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });
    const [addCallBrandList, setAddCallBrandList] = useState(false);

    const { brandInfo, error, loading, loading2, brandStat, brandSelFilterData, brandSelFilterIndex } = useSelector(
        ({ brandItemsReducer, loadingReducer }) => ({
            brandInfo: brandItemsReducer.brandInfo,
            error: brandItemsReducer.error,
            loading: loadingReducer['brand/INFO'],
            loading2: loadingReducer['brand/INFO_ADD'],
            brandStat: brandItemsReducer.brandStat,
            brandSelFilterData: brandItemsReducer.brandSelFilterData,
            brandSelFilterIndex: brandItemsReducer.brandSelFilterIndex,
        })
    );

    useEffect(() => {

        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }
        if (brandInfo !== null && brandSelFilterData !== null && brandSelFilterData.offset !== null) {
            if ((parseInt(brandSelFilterData.offset) + BRAND_ITEM_OFFSET) < brandInfo.totalnum) {
                setAddView(true);
            }
            else {
                setAddView(false);
            }
            setAddCallBrandList(false);
        }
        setScrollPostion({ heignt: 0, isClick: false });

        return () => {
            //console.log( "BrBrandNoContainer end = ");
        };

    }, [brandInfo]);

    const onClickAddView = () => {
        //dispatch(getBrandInfoAction(BrFilterList[index].value,"0","0"));
        let count = parseInt(brandSelFilterData.offset) + BRAND_ITEM_OFFSET;
        if (count < brandInfo.totalnum) {
            //let offset = count.toString();
            dispatch(getBrandInfoAddAction(brandSelFilterData.data, brandSelFilterData.type, count.toString()));
            dispatch(setSetBrandFilterDataAction({ data: brandSelFilterData.data, type: brandSelFilterData.type, offset: count.toString() }));
        }

        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const getNoItemBlock = () => {
        // console.log("getNoItemBlock");
        return (
            <BrandNoItemBloc>
                <BrandNoItemSpanBlock>
                    검색된 브랜드가 없습니다.
                </BrandNoItemSpanBlock>
            </BrandNoItemBloc>
        );
    }

    if (error !== null && error !== undefined && brandInfo === null) {
        // console.log("err = "+error);
        //console.log("brandStat = "+brandStat);
        if (brandStat !== null && brandInfo === null && brandSelFilterIndex === -1 && addCallBrandList === false) {
            setAddCallBrandList(true);
            dispatch(getBrandInfoAction("all", "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "all", type: "0", offset: "0" }));
        }
        else {
            if (addCallBrandList === false)
                return <BrandTableBloc>오류발생</BrandTableBloc>
        }
    }

    if (brandStat !== null && brandInfo !== null && brandInfo.dataList === null) {
        return getNoItemBlock()
    }

    if (brandInfo === null || brandInfo.length === 0 || brandInfo.dataList === null) {
        return <BrandTableBloc>
            <StyleLoader
                active={loading ? loading : (loading2 ? loading2 : false)}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <BrandLoadingItemBloc />
            </StyleLoader></BrandTableBloc>
    }

    return (
        <BrandTableBloc>
            <StyleLoader
                active={loading ? loading : (loading2 ? loading2 : false)}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <BrandTableListUlBloc>
                    {

                        brandInfo.dataList.map((brInfo, index) => {
                            //console.log('brInfo._source.id = '+brInfo._source.id);
                            return <BrBrandAndPdList key={brInfo._source.id.toString()} brInfo={brInfo} />
                        })
                    }

                </BrandTableListUlBloc>
                <BrandAddViewBloc>
                    <BrandAddViewBtnBloc display={addView ? 'inline-block' : "none"} onClick={onClickAddView}>
                        더보기
                    </BrandAddViewBtnBloc>
                </BrandAddViewBloc>
            </StyleLoader>
        </BrandTableBloc>
    );
};

export default BrBrandHomeListContainer;